import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable()
export class SignService {

  api: string = environment.backend;

  constructor(private http: HttpClient) { }

  login(mail, pass) {
    return this.http.post(this.api + 'login', { mail: mail, pass: pass });
  }
}
